import { createStore } from 'vuex'
import { getField, updateField } from "vuex-map-fields";
import clientConfig from '../config/client.mjs';
import premiumVariables from '../config/premiumVariables';

// -----------------------------------------------------

const state = {
  debugMode: false,
  activeTab: 1,

  data: clientConfig.insurancePremiumData,

  modellerName: "Death and Total & Permanent Disability (TPD) Cover",

  age: 30,
  insuranceType: null,
  coverAmount: 1000000,

  premiumVariables: premiumVariables,
};

// -----------------------------------------------------

const mutations = {

  premiumVariables(state, value) {
    state.premiumVariables = value;
  },

  setActiveTab(state, value) {
    state.activeTab = value;
  },

  updateAge(state, value) {
    state.age = value;
  },

  updateInsuranceType(state, value) {
    state.insuranceType = value;
  },

  updateCoverAmount(state, value) {
    state.coverAmount = value;
  },

  updateModellerName(state, value) {
    state.modellerName = value;
  },

  updateField
};

// -----------------------------------------------------

const getters = {
  debugMode: state => {
    return state.debugMode;
  },

  activeTab: state => {
    return state.activeTab;
  },

  data: state => {
    return state.data;
  },

  modellerName: state => {
    return state.modellerName;
  },

  getField
};

export default createStore({
  state,
  mutations,
  getters
});